//angular imports
import { 
  Signal, 
  WritableSignal, 
  computed, 
  signal 
} from "@angular/core";

//local imports
import { IMenu } from "@app/core";
import { IListItem, ListItem, Messenger } from "@app/shared";
import {
  AbstractRoomModel,
  TypedNavItem,
} from "@app/catalog-common";

export abstract class AbstractRoomNavModel<TRoom extends AbstractRoomModel>
  extends TypedNavItem<ListItem<TRoom>>
  implements IMenu
{
  public subMenu?: WritableSignal<IMenu> = signal<IMenu>(null);

  constructor(
    protected messenger: Messenger,
    items: Signal<TRoom[]>,
  ) {
    super();

    this.items = computed(() =>
    items()
      .sort((a,b)=>a.fullName() > b.fullName() ? 1 : -1)
      .map((item) => item.toListItem$(item.isChecked)),
    );
  }

  public abstract select(item: IListItem): void;
}